module.exports = __webpack_public_path__ + "static/img/8.578c94b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/2/zh/8.png
// module id = WNsj
// module chunks = 0